<template>
  <div class="d-flex align-center">
    <v-icon
      v-if="icon"
      class="mr-2"
      :color="small ? '#fe9a00' : 'black'"
      :size="small ? 18 : 22"
    >
      {{ `mdi-${icon}` }}
    </v-icon>

    <div :class="['font-weight-bold', fontSize]">{{ title }}</div>

    <v-tooltip v-if="helpText" bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-icon
          v-bind="attrs"
          v-on="on"
          class="ml-1"
          style="margin-top: 2px"
          color="#6B7280"
          size="14"
        >
          mdi-help-circle-outline
        </v-icon>
      </template>

      <v-sheet class="white--text" color="transparent" max-width="320px">
        {{ helpText }}
      </v-sheet>
    </v-tooltip>
  </div>
</template>

<script>
export default {
  props: {
    small: {
      type: Boolean,
      default: false,
    },
    helpText: {
      type: String,
      default: "",
    },
    icon: {
      type: String,
      default: "",
    },
    title: String,
  },
  computed: {
    fontSize() {
      const size = {
        true: "text-body-1",
      };

      return size[this.small] || "text-h6";
    },
  },
};
</script>
